export function trimInput(formValue: any): any {
  if (!formValue) {
    return;
  }

  formValue = structuredClone(formValue);

  Object.keys(formValue).forEach((control: any) => {
    if (typeof formValue[control] === 'object') {
      trimInput(formValue[control]);
    } else if (typeof formValue[control] === 'string') {
      formValue[control] = formValue[control].replace(/\s{2,}/g, ' ').trim();
    }
  });

  return formValue;
}
